import type { ChatSlots } from "@/core/components/floating-chatbot/slots";
import { ScheduleFormSlot } from "./schedule-form-slot";
import { ScheduleListSlot } from "./schedule-list-slot";

/**
 * Slots que a feature de agendamento de relatório expõe ao chat da Lia.
 * Injetados no `ChatbotProvider` (ver `src/App.tsx`) para manter a dependência na direção
 * `insights → core`, e não o contrário.
 */
export const REPORT_SCHEDULE_CHAT_SLOTS: ChatSlots = {
  schedule_form: ScheduleFormSlot,
  schedule_list: ScheduleListSlot,
};
